<template>
        <div class="is-justify-content-center has-text-centered py-6 px-6" v-if="!did_it_load()"
        style="background:#F8F9FD;">
                <p class="has-text-weight-semibold">&nbsp;
                </p>
        </div> <!-- this previous div is just empty space while the backend loads -->
        <div v-else>
         <!-- but if it loaded, well, this is the actual content -->
            <div class="is-justify-content-center has-text-centered py-6 px-6" 
            style="background:#F8F9FD;" v-if="expired()"> <!-- trial period ended -->
                <p class="has-text-weight-semibold" style="font-size:1.5em">
                Tu periodo de prueba ha terminado. 
                </p>
                <br/>
                <p class="has-text-weight-semibold" style="font-size:1.5em">
                Si quieres seguir obteniendo tu reporte, paga tu Plan Basic aquí
                <a class="button is-secondary is-rounded has-text-weight-semibold"
                style="box-shadow: 4px 4px 1px 0px rgba(0, 0, 255, .2); margin-left: 0.4em;"
                 href="https://app.reveniu.com/checkout-custom-link/qxZ8ewbI6xfOKRBZ59AnWwviYcZibE5r"
                >Contratar</a>
                </p>
            </div> <!-- end trial period ended -->
            <div v-else> <!-- hasn't expired -->
                <div class="has-text-centered has-background-danger" style="color: white; font-weight: bold; font-size: 1.6em;"
                v-if="daysLeft < 31 && does_it_have_a_url_report()"> <!-- but has expiration warnings -->
                    <p v-if="daysLeft < 1">
                        Tu periodo de prueba termina en {{ hoursLeft }} hora<span v-if="hoursLeft > 1">s</span>.
                    </p>
                    <p v-else-if="daysLeft <= 31">
                        Tu periodo de prueba termina en {{ daysLeft }} dia<span v-if="daysLeft > 1">s</span>.
                    </p>
                    <p>
                        <span class="segunda-linea-pagar">
                        <a class="button is-secondary is-rounded has-text-weight-semibold pagar-button"
                        style="box-shadow: 4px 4px 1px 0px rgba(0, 0, 255, .2); margin-left: 0.3em;"
                        href="https://app.reveniu.com/checkout-custom-link/qxZ8ewbI6xfOKRBZ59AnWwviYcZibE5r"
                        >Contrata</a> Plan Basic Mensual de inmediato, o
                        <a class="button is-secondary is-rounded has-text-weight-semibold pagar-button"
                        style="box-shadow: 4px 4px 1px 0px rgba(0, 0, 255, .2); margin-left: 0.3em;"
                        :href="'https://calendly.com/lorena-cforemoto/15min?month=' + currentMonth ">
                        Contáctanos</a> si necesitas un reporte mas avanzado.</span>
                    </p>
                </div>
                <div 
                    :class="{'center-div': isDesktop}"> <!-- center -->
                        <div v-if="user.companies.length > 1" class="pt-3 pb-6 mb-1 mr-percent">
                            <div class="select is-primary is-pulled-right">
                                <select class="custom-select" @change="(e) => changeSelectedCompany(e)">
                                    <option v-for="company in user.companies" class="" :value="company.rut"
                                        v-bind:key="company.rut">
                                        {{ company.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div v-if="does_it_have_a_url_report()"> <!-- has a report -->
                            <div class="is-justify-content-center has-text-centered py-6 px-6" v-if="!has_sii()"
                            style="background:#F8F9FD;"> <!-- but something went wrong at fintoc. A warning. -->
                                    <p class="has-text-weight-semibold" style="font-size:2em">
                                        Ha ocurrido un error con su conexión a SII.
                                    </p>
                                    <p class="has-text-weight-semibold" style="font-size:2em">
                                        Por favor vuelva a registrarse en Fintoc.
                                    </p>
                                    <br/>
                                                    <SIIconnectFast
                                                        :mensajeCorto="true"
                                                        @onConnectSii="onConnectSii"
                                                    />
                            </div> <!-- end has sii div -->
                            <div class="iframecon" style="position: relative;" :style="{ height: iframeHeight }">
                                <iframe v-if="shouldLoad" :src="url" id="iframelooker"
                                scrolling="no" frameborder="0" allowTransparency="true"
                                :style="{ 'padding-left': '5%', 'padding-right': '5%', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden', border: 'none' }"
                                allowfullscreen></iframe> <!-- we show the report whether fintoc is working or not -->
                                <div v-show="shouldLoad" class="blocker" id="blocker" style="position: absolute; bottom: 0; right: 5%; z-index: 100; background-color: #2e2f47; color: #2e2f47;"></div>
                            </div>
                        </div> <!-- end does it have a url report -->
                        <div v-else :class="{'center-div': isDesktop}"
                            class="has-text-centered py-6-diagram px-6-diagram" style="background:#F8F9FD;"> <!-- no report -->
                            <div class="is-justify-content-center" v-if="has_sii()"> <!-- congrats message -->
                                <i class="material-icons is-size-2 icon-clear mr-2 has-text-secondary-light">
                                    info
                                </i>
                                <p class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                ¡Felicitaciones! </p>
                                <br/>
                                <p v-if="user.client_type == 'BASIC'" class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                Tu reporte financiero está en proceso, el siguiente dia hábil
                                podrás volver a entrar con tus credenciales para verlo en línea
                                cuando quieras y desde donde quieras.
                                </p>
                                <p v-else-if="user.client_type == 'ESSENTIAL'" class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                Tu reporte financiero está en proceso.
                                Te notificaremos tan pronto como esté disponible para que puedas acceder con tus credenciales en línea,
                                en cualquier momento y desde cualquier lugar.
                                </p>
                                <p v-else-if="user.client_type == 'ENTERPRISE'" class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                Tu reporte financiero está en proceso.
                                Te notificaremos tan pronto como esté disponible para que puedas acceder con tus credenciales en línea,
                                en cualquier momento y desde cualquier lugar.
                                </p>
                            </div> <!-- end congrats message -->
                            <div class="is-justify-content-center diagram-and-button" v-else> <!-- please complete the registration process -->
                                <Diagram />
                                <br/>
                                <SIIconnectFast
                                    :mensajeCorto="true"
                                    @onConnectSii="onConnectSii"
                                />

                            </div> <!-- end please complete the registration process -->
                        </div> <!-- end no report -->
                </div> <!-- end center -->
            </div> <!-- end hasn't expired -->
            <ResumeClassificationModal
                :active.sync="showClassificationModal"
                :typeOptions="typeOptions"
                :periodDataSelect="periodDataSelect"
                @reloadCounterpart="getAllPaginatedCounterparts"
            />
        </div> <!-- end actual content -->
</template>

<script>
import { getFintocToken, saveFintocUserHolder } from "@/api/fintoc";
import { refresh } from "@/api/security";

import config from "@/config";

import SIIconnectFast from "@/components/fillData/components/SIIconnectFast";
import Diagram from "@/components/fillData/components/Diagram";
import ResumeClassificationModal from "@/components/modals/ResumeClassificationModal";

import { getSession } from "@/utils/auth";
import { mapState, mapActions } from "vuex";

function getUrlOrString(input) {
  if (input == null) return '';
  const trimmed = input.trim();
  if (trimmed === '') return '';

  if (trimmed.startsWith('<')) {
    const match = trimmed.match(/src="([^"]+)"/i);
    return match ? match[1] : trimmed;
  }

  return trimmed;
}


// Start the polling when the window loads

export default {
    name: "DashboardBasic",
    components: {
        SIIconnectFast,
        Diagram,
        ResumeClassificationModal
    },
    data() {
        return {
            blockerX: 100,
            blockerY: 40,
            blockerH: 40,
            blockerW: 400,
            isDesktop: window.innerWidth > 768,
            widgetIsLoading: false,
            hasConnectSII: false,
            daysLeft: -1,
            hoursLeft: -1,
            shouldLoad: false,
            fewSecondsPassed: false,
            waitedPatiently: false,
            delayedFunctionId: -1,
            publicPath: window.location.hostname,
            diagram: Diagram,
            iframeHeight: '1000px',
            iframeHeightRaw: 1000,
            iframeSize: null,
            proportions: '',
            url_report_: '',
            company_selected: null,
            showClassificationModal: false,
        };
    },
    props: {
        isVisible: Boolean,
        chartLoaded: Boolean,
    },
    mounted() {
        window.addEventListener('resize', this.checkScreenSize);
        this.checkScreenSize();
        this.updateIframeHeight();
        window.addEventListener('resize', this.updateIframeHeight);
        this.waitForIframeAndAttachLoadListener();

        this.initClassificationFilters();
        this.getAllAccounts().then(() => {
            this.setSelectedPeriodCounterparts(this.periodDataSelect.find(o => o.value == 'last12'))
            this.getAllPaginatedCounterparts();
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIframeHeight);
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        changeSelectedCompany(event) {
            const rut = event.target.value
            this.company_selected = this.user.companies.find(e => e.rut == rut)
        },
        setIframeSize(rect) {
            this.iframeSize = rect;
        },
        waitForIframeAndAttachLoadListener() {
            const interval = setInterval(() => {
                try {
                    const iframe = document.getElementById('iframelooker');
                    if (iframe) {
                        clearInterval(interval);
                        this.updateIframeHeight();
                    }
                } catch (err) {
                    console.log('Error waiting:', err);
                }
            }, 1000);
        },
        getOffsetRect(el) {
           let rect   = el.getBoundingClientRect();
            // add window scroll position to get the offset position
            let left   = rect.left   + window.scrollX;
            let top    = rect.top    + window.scrollY;
            let right  = rect.right  + window.scrollX;
            let bottom = rect.bottom + window.scrollY;
            // polyfill missing 'x' and 'y' rect properties not returned
            // from getBoundingClientRect() by older browsers
            let x = rect.x === undefined ? left : rect.x + window.scrollX;
            let y = rect.y === undefined ? top : rect.y + window.scrollY;
            // width and height are the same
            let width  = rect.width;
            let height = rect.height;
            return { left, top, right, bottom, x, y, width, height };
        },
        updateIframeHeight() {
            // to make it not scroll, we will force it to keep the 1366x768 proportions
            // the issue is that if the iframe subwindow becomes smaller than
            // the display, it will scroll
            const width = window.innerWidth;
            const height = window.innerHeight;
            this.proportions = width + ' x ' + height
            this.iframeHeightRaw = ((width*0.9) * 768.0 / 1366.0);
            this.iframeHeight =  this.iframeHeightRaw + 'px';
            
            const blocker = document.getElementById('blocker');
            if (blocker) {
                if (width < 200) {
                    blocker.innerHTML = '________';
                } else if (width < 400) {
                    blocker.innerHTML = '____________________';
                } else if (width < 600) {
                    blocker.innerHTML = '______________________________';
                } else if (width < 800) {
                    blocker.innerHTML = '____________________________________________________________';
                } else {
                    blocker.innerHTML = '________________________________________________________________________________';
                }
            }
        },
        did_it_load() {
            if (this.user.user_info_loaded) {
                if (this.user.client_type != 'BASIC') {
                    this.daysLeft = 99999999;
                    this.hoursLeft = 99999999;
                } else {
                    let trialPeriodEnd = this.user.expiration_date;
                    if (trialPeriodEnd) {
                        let trialPeriodEndDate = new Date(trialPeriodEnd);
                        let now = new Date();
                        let periodmili = trialPeriodEndDate.getTime() - now.getTime();
                        let periodDays = periodmili / 1000 / 60 / 60 / 24;
                        let periodHours = periodmili / 1000 / 60 / 60;
                        if (periodDays > 0) {
                            this.daysLeft = parseInt(periodDays);
                        } else {
                            this.hoursLeft = parseInt(periodHours);
                            this.daysLeft = -1;
                        }
                    } else {
                        this.daysLeft = 9999999999;
                    }
                }
            }
            return Boolean(this.user.user_info_loaded);
        },
        does_it_have_a_url_report() {
            const company = this.activeCompany;
            if (!company) return false;
            return Boolean(company.url_report != null && company.url_report.trim() != '');
        },
        has_sii() {
            const company = this.activeCompany;
            if (!company) return false;
            return Boolean((company.account_link &&
                company.account_link.status &&
                company.account_link.status == 'OK' &&
                company.account_link.link_token_valid == true) ||
                (this.user.no_sii_message == true));
        },
        checkScreenSize() {
            this.isDesktop = window.innerWidth > 768;
        },
        updateShouldLoad(isVisible, chartLoaded) {
            if (isVisible && chartLoaded) {
                this.shouldLoad = true;
                if (!this.waitedPatiently) {
                    if (this.delayedFunctionId !== -1) clearTimeout(this.delayedFunctionId);
                    this.delayedFunctionId = setTimeout(() => {
                        this.waitedPatiently = true;
                    }, 5000);
                }
            } else if (!isVisible && !this.waitedPatiently) {
                if (this.delayedFunctionId !== -1) clearTimeout(this.delayedFunctionId);
                this.shouldLoad = false;
            }
        },
        onConnectSii() {
            const product_type = "invoices";
            const company_rut = this.activeCompany.rut
            this.widgetIsLoading = true;
            getFintocToken({ product_type: product_type, company_rut })
                .then((response) => {
                    this.widget = window.Fintoc.create({
                        holderType: "business",
                        product: product_type,
                        publicKey: response.data.public_key,
                        webhookUrl: `${config.webhookAPI}/fintoc_app/link_token/?token=${response.data.webhook_token}`,
                        onExit: () => this.onWidgetExit(),
                        onSuccess: (link) =>
                            this.onWidgetSuccess(
                                response.data["company_product_link"]["id"],
                                link
                            ),
                    });
                    this.widget.open();
                    this.widgetIsLoading = false;
                })
                .catch(() => {});
        },
        async onWidgetSuccess(id, linkp) {
            linkp["company_product_link_id"] = id;
            await saveFintocUserHolder(linkp);
            const session = getSession();
            await refresh(session.token);
            this.hasConnectSII = true;
        },
        onWidgetExit() {
            this.widget.destroy();
        },
        expired() {
            let daysLeft = this.daysLeft;
            return daysLeft < 0;
        },
        ...mapActions("classification", ["initClassificationFilters", "getAllAccounts", "setSelectedPeriodCounterparts", "getAllCounterparts", "updateDataCharts"]),
        async getAllPaginatedCounterparts() {
            if (!this.selectedPeriodCounterparts) return;
            let request = {
                from: 0,
                to: 999999,
                from_day: this.selectedPeriodCounterparts.from,
                to_day: this.selectedPeriodCounterparts.to,
            };
            await this.getAllCounterparts(request)
            this.updateDataCharts();
        },
    },
    computed: {
        ...mapState("userAuth", ["user", "hasSIIAutomation"]),
        ...mapState("classification", ["typeOptions", "periodDataSelect", "selectedPeriodCounterparts"]),
        activeCompany() {
            if (this.user && this.user.companies && this.user.companies.length > 0) {
                if (this.user.companies.length === 1) {
                    return this.user.companies[0];
                }
                if (this.company_selected) {
                    return this.user.companies.find(c => c.rut === this.company_selected.rut) || this.user.companies[0];
                }
                return this.user.companies[0];
            }
            return null;
        },
        url: {
            get: function () {
                return this.url_report_
            },
            set: function (url_report) {
                this.url_report_ = getUrlOrString(url_report)
            },
        },
        currentMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1; 
            const formattedMonth = month.toString().padStart(2, '0');
            return `${year}-${formattedMonth}`;
        },
    },
    watch: {
/* ugh, maquina de estado del infierno
 * básicamente, miramos el booleano isVisible, que controla si esta pestaña se muestra (en Dashboard.vue)
 * if:
 * estamos mostrando la pestaña Y el gráfico en el conciliador terminó de cargar, permitimos que se cargue el iframe.
 * (ten en cuenta que las pestañas del Encabezado deberían asegurarse de que la pestaña del informe no sea clickeable
 * si el gráfico en el informe no conciliador, es decir, si chartLoaded es falso)
 * ENTONCES, si el usuario NO ha esperado pacientemente, el componente esperará 5 segundos; si esta espera termina,
 * "waitPatiently" ahora es verdadero para siempre, y el gráfico de looker studio no se recargará.
 * esto significa que waitPatiently solo se vuelve verdadero UNA VEZ
 *
 * else if:
 * en caso contrario, si este componente está oculto, entonces verificamos si el usuario ha esperado pacientemente al menos una vez:
 * Si el usuario ha esperado pacientemente al menos una vez, significa que shouldLoad no deberia cambiar.
 * de otra forma, llega al clearTimeout, lo que significa que el usuario hizo clic en otra pestaña y deberíamos cancelar la espera.
 * Eso marca al usuario como que ha esperado pacientemente; luego "shouldLoad" se marca como falso, lo que descarga el iframe.
 * El usuario debera volver a empezar a cargar la pagina y esperar pacientemente.
 * 
 * Este if deberia poder manejar el caso de tres o mas tabs, pero seria bueno probarlo.
 */
        isVisible: {
            handler(newValue) {
                this.updateShouldLoad(newValue, this.chartLoaded);
            },
            immediate: true
        },
        chartLoaded: {
            handler(newValue) {
                this.updateShouldLoad(this.isVisible, newValue);
            },
            immediate: true
        },
        shouldLoad(newValue) {
            if (newValue) {
                this.showClassificationModal = true;
            }
        },
        activeCompany: {
            handler(newCompany) {
                if (newCompany) {
                    this.url = newCompany.url_report || '';
                }
            },
            immediate: true
        }
    }
};
</script>

<style scoped>
.center-div {
    width: 100%;
    height: 90%;
    margin: auto;
}

@media screen and (max-width: 768px) {
  .center-div {
    display: block; /* or whatever your mobile styling is */
  }
}
.segunda-linea-pagar {
    font-size: 80%;
}
.pagar-button {
    position: relative;
    bottom: 3px;
}
.py-6-diagram {
    padding-top: 2em;
}
.px-6-diagram {
    padding-left: 0;
    padding-right: 0;
}

.mr-percent {
    margin-right: 5%;
}

.custom-select {
    font-weight: bold;
    font-size: 1.2rem;
}

.custom-select option {
    font-weight: normal;
    font-size: initial;
}
</style>
